import { Flex } from 'antd'
import React from 'react'

import SectionTitle from '../section-title'

import ChatterPerformanceChart, {
  ChartData,
  StrokeColors,
} from './chatter-performance-line-chart'

export interface ChatterPerformanceGoldenRatioProps {
  data: ChartData
}

export default function ChatterPerformanceGoldenRatio({ data }: ChatterPerformanceGoldenRatioProps) {
  return (
    <Flex vertical gap={8}>
      <SectionTitle
        title="Golden ratio"
        tooltip="The ratio between total PPVs and messages sent during this period. 100% shows potential overuse of paid messages."
      />
      <ChatterPerformanceChart data={data} stroke={StrokeColors.GoldenRatio} />
    </Flex>
  )
}
